<template>
  <div v-if="!hide" class="section-wrapper text-left mb-4">
    <h3 class="title">{{ title }}</h3>
    <p class="description">{{ description }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    hide: { type: Boolean, required: false }
  }
}
</script>

<style scoped>
.section-wrapper {
  background-color: #f7fbfc;
  padding: 24px 72px;
  border-radius: 8px;
}

.title {
  font-weight: 400;
  font-size: 20px;
  color: #00903c;
}

.description {
  font-weight: 500;
  font-size: 12px;
  max-width: 800px;
}
@media screen and (max-width: 576px) {
  .section-wrapper {
    padding: 24px 16px;
  }
}
</style>
